import CSS from 'csstype';
import React from 'react';

import { FONT_WEIGHT, fontSizing } from '~/src/dash/components/text/common';
import {
  Col,
  Cols,
  spacing,
  TooltipWithTranslation,
  usePublicaTranslation,
} from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { DateRange, IDateRange, ITimeRange, TimeRange } from '~/src/dash/utils/dateTimeRanges';
const getColStyle = (idx: number, isLast?: boolean): CSS.Properties => {
  if (isLast) {
    return {
      borderRadius: '0 5px 5px 0',
      borderLeft: 'none',
    };
  }
  if (idx === 0) {
    return {
      borderRadius: '5px 0 0 5px',
    };
  } else {
    return {
      borderRadius: 'none',
      borderLeft: 'none',
    };
  }
};

interface IProps {
  backgroundColor?: string;
  isDisabled?: boolean;
  checkIsRangeDisabled?: (range: IDateRange | ITimeRange) => boolean;
  ranges: IDateRange[] | ITimeRange[];
  activeKey: DateRange | TimeRange;
  onClick: (rangeKey: DateRange | TimeRange) => void;
  style?: CSS.Properties;
}

export const DateTimeRangeToggles = ({
  backgroundColor = 'inherit',
  isDisabled = false,
  checkIsRangeDisabled = () => false,
  ranges,
  activeKey,
  onClick,
  style,
}: IProps) => {
  const numRanges = ranges.length - 1;
  const { t } = usePublicaTranslation();
  return (
    <Cols
      style={{
        alignItems: 'center',
        rowGap: spacing.extraSmall,
        flexWrap: 'nowrap',
      }}
    >
      {ranges.map((range, i) => {
        const isActive = activeKey === range.key;
        let color = isActive ? publicaColors.veryDarkGray : publicaColors.darkGray;
        let background = isActive ? publicaColors.lavender : backgroundColor;
        const isRangeDisabled = isDisabled || checkIsRangeDisabled(range);
        if (isRangeDisabled) {
          color = publicaColors.gray;
          background = isActive ? publicaColors.lightGray : publicaColors.veryLightGray;
        }

        return (
          <Col key={range.shortLabel}>
            <TooltipWithTranslation
              tKey={range.tKey}
              title={range.extendedLabel || range.label}
              placement='top'
              enterDelay={500}
              enterNextDelay={500}
            >
              <button
                onClick={() => onClick(range.key)}
                style={{
                  display: 'inline-block',
                  borderWidth: 0,
                  lineHeight: 'inherit',
                  fontFamily: 'inherit',
                  fontStyle: 'inherit',
                  whiteSpace: 'nowrap',
                  margin: 0,
                  background,
                  color,
                  transition: 'background 0.2s ease-out',
                  minWidth: '40px',
                  textAlign: 'center',
                  fontSize: fontSizing.small,
                  fontWeight: isActive ? FONT_WEIGHT.bold : FONT_WEIGHT.base,
                  border: `1px solid ${publicaColors.lightGray}`,
                  padding: '4px 12px',
                  cursor: isRangeDisabled ? 'not-allowed' : 'pointer',
                  pointerEvents: isRangeDisabled ? 'none' : 'all',
                  ...getColStyle(i, i === numRanges),
                  ...style,
                }}
              >
                {range.shortTKey ? t(range.shortTKey) : range.shortLabel}
              </button>
            </TooltipWithTranslation>
          </Col>
        );
      })}
    </Cols>
  );
};
